module.exports = "/images/NewArrow.png?22e0b0e96d4a8a492560aa6f3a27cd50";